export default {
      id: "chevron-left-usage",
      viewBox: "0 0 6.265 11.531",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#chevron-left",
      toString: function () {
        return this.url;
      }
    }